import React from "react";
import SignupForm from "../components/auth/SignupForm";
import AuthPageShell from "../components/auth/AuthPageShell";
import useAuthPageRedirect from "../hooks/useAuthPageRedirect";

const SignupPage = () => {
  const { onSuccess, goToLogin } = useAuthPageRedirect();

  return (
    <AuthPageShell>
      <SignupForm onClose={onSuccess} switchToLogin={goToLogin} />
    </AuthPageShell>
  );
};

export default SignupPage;
